import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType} from '../../../utils/commonPropTypes'
import WidthContainer from '../../../components/WidthContainer'
import Blob from '../../../components/Blob'
import List from '../../../components/List'
import {QueryedButton} from '../../../components/Button'

import illustration from '../images/aboutIllustration.svg'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled(WidthContainer)`
	padding-bottom: 4rem;
	
	.smallOnly {
		display: none;
	}
		
	${phoneBreakpoint} {
		padding-bottom: 0;
		.smallOnly {
			display: block;
		}
		
		.bigOnly {
			display: none;
		}
	}
`

const InnerContainer = styled.div`
	display: flex;
	margin: 0 -5rem;
	
	${phoneBreakpoint} {
		flex-direction: column;
		align-items: center;
	}
`

const Column = styled.div`
	flex: 1;
	margin: 0 5rem; 
	max-width: 26.875rem;
`

const Title = styled.h1`
	margin-bottom: 2.5rem;
	margin-top: 4rem;
	
	@media only screen and (max-width: 700px) {
		font-size: ${props => props.theme.fontSizes.big30};
	}
`

const Text = styled.div`
	margin-bottom: 3rem;
`

const GoalsTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big18};
	font-weight: ${props => props.theme.fontWeights.bold};
	text-transform: uppercase;
	margin-bottom: 2.5rem;
`


const Illustration = styled.img`
`
Illustration.defaultProps = {
	src: illustration,
	alt: '',
}

const GoalsList = styled(List)`
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 3rem;
`

const BlobTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 1rem;
`

const AboutGoalsSection = ({className, data}) => <RootContainer className={className}>
	<InnerContainer>
		<Column>
			<Illustration className='smallOnly'/>
			<Title>{data.title}</Title>
			<Text>{data.text}</Text>
			<GoalsTitle>{data.goals.title}</GoalsTitle>
			<GoalsList items={data.goals.items.map(one => one.text)}/>
		</Column>
		<Column>
			<Illustration className='bigOnly'/>
			<Blob blobType={1}>
				<BlobTitle>
					{data.join.title}
				</BlobTitle>
				<QueryedButton data={data.join.button}/>
			</Blob>
		</Column>
	</InnerContainer>
</RootContainer>

AboutGoalsSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		goals: PropTypes.shape({
			title: PropTypes.string.isRequired,
			items: PropTypes.shape({
				text: PropTypes.string.isRequired,
			}),
		}).isRequired,
		join: PropTypes.shape({
			title: PropTypes.string.isRequired,
			button: buttonType.isRequired,
		}).isRequired,
	}),
}

AboutGoalsSection.defaultProps = {
	className: '',
}

export default AboutGoalsSection
